// Crea un nuovo file: operation-status.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leftPad',
  standalone: true
})
export class LeftPadPipe implements PipeTransform {
  transform(value: any, length: number = 2, character: string = '0'): string {
    if (value === null || value === undefined) return '';
    return String(value).padStart(length, character);
  }
}